/** Средний радиус Земли, км (IUGG). */
const EARTH_RADIUS_KM = 6371.0088;
const toRad = (deg) => (deg * Math.PI) / 180;
/**
 * Площадь кольца по формуле сферического избытка, км².
 *
 * Плоская формула на широте Ташкента ошибается меньше чем на процент, но зоны
 * рисуют и на 465 км², и на 0.8 км² — считать честно дешевле, чем объяснять
 * расхождение с `ST_Area(geom::geography)`.
 *
 * Знак зависит от направления обхода, а направление исполнителю не подвластно:
 * палец идёт как идёт. Поэтому берём модуль.
 */
function ringAreaKm2(ring) {
    if (ring.length < 4)
        return 0;
    let total = 0;
    for (let i = 0; i < ring.length - 1; i += 1) {
        const [lon1, lat1] = ring[i];
        const [lon2, lat2] = ring[i + 1];
        total += toRad(lon2 - lon1) * (2 + Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
    }
    return Math.abs((total * EARTH_RADIUS_KM * EARTH_RADIUS_KM) / 2);
}
/**
 * Площадь полигона, км². Кольца после первого — вырезы, их площадь вычитается.
 *
 * Незамкнутое кольцо сюда не приходит: замкнутость стережёт контракт
 * `geoJsonPolygon`, а в базе — `CHECK ST_IsValid`.
 */
export function polygonAreaKm2(polygon) {
    const [outer, ...holes] = polygon.coordinates;
    if (!outer)
        return 0;
    const area = ringAreaKm2(outer) - holes.reduce((sum, hole) => sum + ringAreaKm2(hole), 0);
    return Math.max(area, 0);
}
//# sourceMappingURL=geo.js.map